import { useEffect, useRef } from 'react'

import { useMutationObserver } from '@/hooks/useMutationObserver'

const useHtmlObserver = () => {
  const htmlRef = useRef<HTMLHtmlElement | null>(null)

  useEffect(() => {
    htmlRef.current = document.getElementsByTagName('html').item(0)
  }, [])

  // @ts-expect-error ignore
  const mutations = useMutationObserver<HTMLHtmlElement>(htmlRef, {
    attributes: true,
    attributeFilter: ['style'],
  })

  useEffect(() => {
    if (!mutations) return

    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        const target = mutation.target as HTMLElement
        if (target.style.overflowY) {
          // Remove overflow-y when detected
          target.style.removeProperty('overflow-y')
        }
      }
    })
  }, [mutations])
}

export default useHtmlObserver
